import { render, staticRenderFns } from "./rate-max-editor.vue?vue&type=template&id=59c5a4f2&scoped=true&"
import script from "./rate-max-editor.vue?vue&type=script&lang=js&"
export * from "./rate-max-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c5a4f2",
  null
  
)

export default component.exports